export enum ROUTES {
  HOME = '/',
  LOGIN = '/log-in',
  COMPANIES = '/companies',
  ANALYTICS = '/analytics',
  CREATE_COMPANY = '/companies/create',
  PITCHBOOK = '/pitchbook',
  COMPANY = '/companies/:id',
  EDIT_COMPANY = '/companies/:id/edit',
  GENERATED_LINK = '/generated-link',
  NOT_FOUND = '/*',
}

export enum ADMIN_ROUTES {
  HOME = '/admin-panel',
  LOGIN = '/admin-panel/log-in',
  USERS = '/admin-panel/users',
  DELETED_COMPANIES = '/admin-panel/deleted-companies',
  CREATE_USER = '/admin-panel/users/create',
  EDIT_USER = '/admin-panel/users/:id/edit',
  EXTERNAL_USERS = '/admin-panel/external-users',
}
